import type { CSSProperties, ReactNode } from "react"
import { cx } from "classix"
import styles from "./index.module.scss"

export type InfoListItem = {
	key?: string | number,
	label?: ReactNode,
	content?: ReactNode,
	style?: CSSProperties
}

export type InfoListProps = {
	itemLabelStyle?: CSSProperties,
	itemContentStyle?: CSSProperties,
	itemStyle?: CSSProperties,
	itemClassName?: string,
	itemContentClassName?: string,
	itemLabelClassName?: string,
	itemsClassName?: string,
	itemsStyle?: CSSProperties,
	items: InfoListItem[],
	itemWrap?: boolean
}

export function InfoList({
							 items,
							 itemStyle,
							 itemClassName,
							 itemLabelClassName,
							 itemContentClassName,
							 itemLabelStyle,
							 itemContentStyle,
							 itemsStyle,
							 itemsClassName,
							 itemWrap = false
						 }: InfoListProps) {

	return <div style={itemsStyle} className={cx(styles.items, itemsClassName)}>
		{items.map((item, i) => item.label
			? (
				<div key={item.key ?? i} className={cx(styles.item, itemWrap && styles.wrap, itemClassName)}
					 style={{ ...itemStyle, ...item.style }}>
					<div className={cx(styles.label, itemLabelClassName)} style={itemLabelStyle}>{item.label}</div>
					<div className={cx(styles.content, itemContentClassName)}
						 style={itemContentStyle}>{item.content}</div>
				</div>
			)
			: (
				<div key={item.key ?? i} className={cx(styles.item, styles.content)}
					 style={itemContentStyle}>{item.content}</div>
			)
		)}
	</div>
}